import communityHero from '../../assets/landing/community-hero.png';
import icon01 from '../../assets/landing/icon-01.svg?url';
import icon02 from '../../assets/landing/icon-02.svg?url';
import icon03 from '../../assets/landing/icon-03.svg?url';
import icon04 from '../../assets/landing/icon-04.svg?url';
import icon05 from '../../assets/landing/icon-05.svg?url';
import icon06 from '../../assets/landing/icon-06.svg?url';
import icon07 from '../../assets/landing/icon-07.svg?url';

export const LANDING_IMAGES = {
    communityHero,
    icon01,
    icon02,
    icon03,
    icon04,
    icon05,
    icon06,
    icon07,
};
